import axiosInstance from "../Config/axiosConfig";

export const loginUser = async (credentials, deviceId, userIp) => {
  try {

    const response = await axiosInstance.post("User/signin", credentials, {
      headers: {
        "UserDevice": deviceId,
        "UserIPAddress": userIp,
      },
    });

    console.log("Response:", response.data);

    return response.data;
  } catch (error) {
    console.error("Login error:", error.response?.data || error.message);
    throw error.response?.data?.message || "Login failed. Please check your credentials.";
  }
};